import React, { useState } from 'react';
import './style/VerifyCode.css';
import { useNavigate } from 'react-router-dom';

const PhoneNumberModal = () => {
    const [phone, setPhone] = useState('');
    const [message, setMessage] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async () => {
        if (!phone) return;

        try {
            const response = await fetch('http://localhost:8081/api/users/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'User-Agent': 'insomnia/11.1.0',
                },
                body: JSON.stringify({
                    full_name: '',
                    phone_number: phone,
                    passport_number: '',
                }),
            });

            if (response.ok) {
                const userId = await response.text();
                localStorage.setItem('userId', userId);
                localStorage.setItem('userId_createdAt', new Date().toISOString());
                localStorage.setItem('phoneNumber', phone);
                navigate('/verify-code', { state: { phone, flag: 'profile' } });
            } else {
                setMessage('Пользователь не зарегистрирован или произошла ошибка.');
            }
        } catch (error) {
            console.error('Ошибка при создании пользователя:', error);
            setMessage('Ошибка соединения с сервером.');
        }
    };

    const handleClose = () => {
        navigate('/'); // переход на главную
    };

    return (
        <div className="modal-overlay">
            <div className="modal">
                <h2>Введите номер телефона</h2>
                <input
                    type="text"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    placeholder="Номер телефона"
                />
                <button onClick={handleSubmit}>Получить код</button>
                <button onClick={handleClose} style={{ marginTop: '10px', backgroundColor: '#ccc' }}>
                    Закрыть
                </button>
                {message && <p style={{ color: 'red', marginTop: '10px' }}>{message}</p>}
            </div>
        </div>
    );
};

export default PhoneNumberModal;
